import React from 'react';
import cn from 'classnames';

const EditAddressesPage = ({ className }) => {
  return <div className={cn(className)}>Edit Addresses Page</div>;
};

export default EditAddressesPage;
